import type {ReactElement, VFC} from 'react';

import {Typography, VARIANTS} from '@/components/base/typography/Typography';

import Messages from './assets/messages_outline_28.svg';
import Services from './assets/services_outline_28.svg';
import Stars from './assets/stars_outline_28.svg';
import StickerSmile from './assets/sticker_smile_outline_28.svg';
import ThumbsUp from './assets/thumbs_up_outline_28.svg';
import View from './assets/view_outline_28.svg';
import styles from './SurveyUsers.module.css';

type ItemProps = {
	id: number;
	title: string | ReactElement;
	text: string | ReactElement;
	img: VFC<React.SVGProps<SVGSVGElement>>;
};

export const data: ItemProps[] = [
	{
		id: 0,
		title: <div className={styles.contentTitle}>Топ-менеджерам</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Автоматизируйте сбор обратной связи у&nbsp;руководителей <br />и подчиненных, определяйте
				слабые и&nbsp;сильные стороны персонала
			</Typography>
		),
		img: Stars,
	},
	{
		id: 1,
		title: <div className={styles.contentTitle}>HR-команде</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Анализируйте удовлетворенность и&nbsp;вовлеченность персонала, собирайте фидбэк от&nbsp;команд
				после&nbsp;внедрения фич&nbsp;или&nbsp;проведения мероприятий
			</Typography>
		),
		img: ThumbsUp,
	},
	{
		id: 2,
		title: <div className={styles.contentTitle}>Команде адаптации</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Следите за&nbsp;онбордингом с&nbsp;помощью онлайн-анкет для&nbsp;сотрудников,
				чтобы&nbsp;вовремя понять, когда нужно помочь новичкам влиться в&nbsp;коллектив
			</Typography>
		),
		img: StickerSmile,
	},
	{
		id: 3,
		title: <div className={styles.contentTitle}>Команде обучения</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Тестируйте знания персонала, используйте систему корпоративных опросов, чтобы&nbsp;собирать
				отзывы по&nbsp;качеству обучающих программ
			</Typography>
		),
		img: Messages,
	},
	{
		id: 4,
		title: <div className={styles.contentTitle}>Сервисным отделам и службам поддержки</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Проводите опросы, чтобы&nbsp;учитывать мнение сотрудников и&nbsp;улучшать
				для&nbsp;них&nbsp;качество сервиса
			</Typography>
		),
		img: Services,
	},
	{
		id: 5,
		title: <div className={styles.contentTitle}>Всем сотрудникам</div>,
		text: (
			<Typography variant={VARIANTS.text} className={styles.contentText}>
				Используйте сервис для&nbsp;проведения опросов, чтобы&nbsp;принимать решения по&nbsp;сложным
				вопросам онлайн вместе с&nbsp;коллегами
			</Typography>
		),
		img: View,
	},
];
